import request from '@/request/'

export function login (username, password) {
  return request({
    url: '/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo () {
  return request({
    url: '/userinfo',
    method: 'get'
  })
}

export function logout () {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js